import { Tab, TabList, TabPanels, Tabs, TabsProps } from '@chakra-ui/react';
import React from 'react';

type Props = {
  tabNames: string[];
} & TabsProps;

export const TABLIST_ID = 'tab-list';

export const CmTabs: React.FC<Props> = ({
  size = 'md',
  variant = 'enclosed',
  tabNames,
  children,
  index,
  defaultIndex,
  onChange,
}): JSX.Element => {
  return (
    // @ts-ignore TS2590
    <Tabs
      {...{ size, variant, index, defaultIndex, onChange }}
      borderColor="#A0AEC0"
    >
      <TabList id={TABLIST_ID}>
        {tabNames.map((tabName) => (
          <Tab
            _selected={{
              borderTopColor: '#A0AEC0',
              borderLeftColor: '#A0AEC0',
              borderRightColor: '#A0AEC0',
              bg: 'white',
            }}
            key={tabName}
          >
            {tabName}
          </Tab>
        ))}
      </TabList>
      <TabPanels>{children}</TabPanels>
    </Tabs>
  );
};
